import PropTypes from "prop-types";

export const historyEntryShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  kind: PropTypes.string.isRequired,
  amountCents: PropTypes.number.isRequired,
  balanceAfterCents: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  venueName: PropTypes.string,
});

export const giftCardShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  last4: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  whereItWorks: PropTypes.string.isRequired,
  balanceCents: PropTypes.number.isRequired,
  expiredCents: PropTypes.number.isRequired,
  expiredAt: PropTypes.string,
  initialValueCents: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  expiresAt: PropTypes.string,
  artworkUrl: PropTypes.string,
  mergeTargetIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  history: PropTypes.arrayOf(historyEntryShape).isRequired,
  codeRevealPath: PropTypes.string.isRequired,
  codeEmailPath: PropTypes.string.isRequired,
  ownerEmail: PropTypes.string.isRequired,
  printablePath: PropTypes.string.isRequired,
  mergePath: PropTypes.string.isRequired,
});
